import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "./api";

export interface TrackSongCode {
  track_id: string;
  code: string;
  expires_at: string;
}

/**
 * 곡마다 노래 코드(026). `trackKey` 가 바뀌면(새 곡이 생기면) 다시 읽는다.
 * 옛 방식 수업은 고른 곡 한 줄만 돌아온다. 못 읽어도 화면은 코드 없이 그대로 간다.
 */
export function useSongCodes(
  workId: string,
  trackKey: string,
): { codes: Map<string, TrackSongCode>; reload: () => void } {
  const [codes, setCodes] = useState<Map<string, TrackSongCode>>(() => new Map());
  // 첫 조회가 실패했거나 완성으로 새 코드가 생겼을 때 다시 읽는다(Codex 검수 4).
  const [revision, setRevision] = useState(0);
  const reload = useCallback(() => setRevision((value) => value + 1), []);
  useEffect(() => {
    if (!trackKey) return;
    let active = true;
    void apiRequest<{ codes: TrackSongCode[] }>(`/api/works/${encodeURIComponent(workId)}/song-codes`)
      .then((response) => {
        if (active) setCodes(new Map(response.codes.map((item) => [item.track_id, item])));
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [workId, trackKey, revision]);
  return { codes, reload };
}
